import "./ui.css";

/**
 * Dumaloq diagramma (donut).
 *
 * Kutubxona qo'shilmadi: bitta diagramma uchun grafik paket olib
 * kelish Electron paketini ham kattalashtirardi. SVG yoyi — bir
 * nechta qator kod.
 *
 * Halqa, to'liq doira emas: o'rtadagi bo'shliqqa jami qiymat
 * yoziladi va u diagrammaning eng muhim sonini ko'rsatadi.
 */

export interface DonutSlice {
  key: string;
  label: string;
  value: number;
  color: string;
}

const SIZE = 180;
const STROKE = 28;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function Donut({
  slices,
  total,
  centerValue,
  centerLabel,
}: {
  slices: DonutSlice[];
  /** Maxraj: ulushlar shu songa nisbatan hisoblanadi. */
  total: number;
  centerValue: string;
  centerLabel: string;
}) {
  // Nol maxrajda bo'sh halqa: nolga bo'lish `NaN` berib, butun
  // diagrammani yo'qotardi.
  const positive = total > 0 ? slices.filter((slice) => slice.value > 0) : [];

  let offset = 0;
  const arcs = positive.map((slice) => {
    const share = slice.value / total;
    const arc = {
      key: slice.key,
      color: slice.color,
      length: share * CIRCUMFERENCE,
      offset,
      label: slice.label,
      percent: share * 100,
    };
    offset += arc.length;
    return arc;
  });

  return (
    <div className="donut">
      <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="donut-svg" role="img"
        aria-label={`${centerLabel}: ${centerValue}`}>
        {/* Fon halqasi: ulushlar jami 100% dan kam bo'lsa
            (yaxlitlash yoki kesimsiz qoldiq) bo'shliq ko'rinadi. */}
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={RADIUS}
          fill="none" strokeWidth={STROKE} className="donut-track"
        />
        {arcs.map((arc) => (
          <circle
            key={arc.key}
            cx={SIZE / 2} cy={SIZE / 2} r={RADIUS}
            fill="none" stroke={arc.color} strokeWidth={STROKE}
            strokeDasharray={`${arc.length} ${CIRCUMFERENCE - arc.length}`}
            strokeDashoffset={-arc.offset}
            // Yoy tepadan boshlanadi: sukut bo'yicha SVG o'ngdan
            // boshlaydi va diagramma qiyshiq ko'rinardi.
            transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
          >
            <title>{`${arc.label}: ${arc.percent.toFixed(1)}%`}</title>
          </circle>
        ))}
      </svg>

      <div className="donut-center">
        <div className="donut-value num">{centerValue}</div>
        <div className="donut-label">{centerLabel}</div>
      </div>
    </div>
  );
}
